import React from 'react'

import Dashboard from 'pages/dashboard/Dashboard'
import Profile from 'pages/profile/Profile'
import Login from 'pages/auth/Login'
import Register from 'pages/auth/Register'
import LupaPassword from 'pages/auth/LupaPassword'
import BuatPassword from 'pages/auth/BuatPassword'
import KatalogLagu from 'pages/katalogLagu/KatalogLagu'
import RegisterReq from 'pages/katalogLagu/RegisterReq'
import Transaksi from 'pages/transaksi/Transaksi'
import AddTransaksi from 'pages/transaksi/AddTransaksi'
import Pencipta from 'pages/anggota/Pencipta/Pencipta'
import Admin from 'pages/anggota/Admin/Admin'
import Pendapatan from 'pages/laporan/pendapatan'
import Distribusi from 'pages/laporan/distribusi'
import DistribusiDsp from 'pages/laporan/DistribusiDsp'
import VerifikasiPassword from 'pages/auth/VerifikasiPassword'
import DraftKontrak from 'pages/draftKontrak/DraftKontrak'
import Bantuan from 'pages/bantuan/Bantuan'
import AhliWaris from 'pages/ahliWaris/AhliWaris'
import { DRAFT_KONTRAK_PATH, KATALOG_LAGU_PATH, REGISTER_REQ_PATH } from 'utils/paths'


// import pakai react lazy butuh suspense fallback di app.js

// const Login = React.lazy(() => import('pages/auth/Login'))
// const Register = React.lazy(() => import('pages/auth/Register'))
// const LupaPassword = React.lazy(() => import('pages/auth/LupaPassword'))
// const BuatPassword = React.lazy(() => import('pages/auth/BuatPassword'))
// const Dashboard = React.lazy(() => import('pages/dashboard/Dashboard'))
// const Profile = React.lazy(() => import('pages/profile/Profile'))

const routes = [
  {
    path: "/",
    component: Dashboard
  },
  {
    path: "/profile",
    component: Profile
  },
  {
    path: "/auth/login",
    component: Login
  },
  {
    path: "/auth/reset-password",
    component: VerifikasiPassword
  },
  {
    path: "/auth/register",
    component: Register
  },
  {
    path: "/auth/lupa-password",
    component: LupaPassword
  },
  {
    path: "/auth/buat-password",
    component: BuatPassword
  },
  {
    path: KATALOG_LAGU_PATH,
    component: KatalogLagu
  },
  {
    path: REGISTER_REQ_PATH,
    component: RegisterReq
  },
  {
    path: "/transaksi",
    component: Transaksi
  },
  {
    path: "/transaksi/create",
    component: AddTransaksi
  },
  {
    path: "/transaksi/detail",
    component: AddTransaksi
  },
  {
    path: "/transaksi/edit",
    component: AddTransaksi
  },
  {
    path: "/transaksi/summary",
    component: AddTransaksi
  },
  {
    // Menu Anggota tidak diperuntukkan bagi pencipta (role_code 3).
    path: "/pencipta",
    component: Pencipta,
    deniedRoles: [3]
  },
  {
    path: "/admin",
    component: Admin,
    deniedRoles: [3]
  },
  {
    // Hanya untuk anggota yang belum punya mamboo_id. Begitu diaktivasi admin,
    // halaman ini tidak relevan lagi dan aksesnya ditutup.
    path: DRAFT_KONTRAK_PATH,
    component: DraftKontrak,
    onboardingOnly: true
  },
  {
    path: "/pendapatan",
    component: Pendapatan
  },
  {
    path: "/distribusi",
    component: Distribusi
  },
  {
    // Pembacaan & pemetaan laporan DSP. Masih tahap pemetaan: belum
    // menyimpan apa pun ke database.
    path: "/distribusi-dsp",
    component: DistribusiDsp
  },
  {
    path: "/bantuan",
    component: Bantuan
  },
  {
    // Tanpa deniedRoles: halaman ini terbuka untuk semua peran.
    path: "/ahli-waris",
    component: AhliWaris
  }
]

export default routes


